<template>
	<div>
		<div v-if='toolsDetail'>
			<div class="header">
				<div style="display: flex;align-items: center;">
					<img src="../../assets/images/indexIcon.png" alt="">
					<p><span>首页-资源工具池</span>-{{toolsDetail.title}}</p>
				</div>
				<div class="backof" @click="$router.go(-1)">返回</div>
			</div>
			<div class="body">
				<div class="body-left">
					<div class="left-head">
						求助人
					</div>
					<div class="left-body" v-if="toolsDetail.user_info != null">
						<div class="body-item">
							<div class="item-title">
								{{toolsDetail.user_info.nickname}}
							</div>
							<div class="item-content">

								联系方式:{{toolsDetail.user_info.mobile.slice(0, 3) + '****' + toolsDetail.user_info.mobile.slice(7) || toolsDetail.user_info.email}}
							</div>
						</div>
						<!-- <div class="body-item">
							<div class="item-title">
								时间线
							</div>
							<div class="item-content">
								创建时间:2022-5-9
							</div>
							<div class="item-content">
								修改时间:2023-8-9
							</div>
						</div> -->
						<div class="body-item">
							<div class="item-title">
								有相同需求
							</div>
							<div class="item-content" v-for="(item,index) in toolsDetail.raise_lists">
								{{item.nickname}}
							</div>
						</div>

					</div>
					<div class="left-body" v-else>
						<div class="body-item">
							<div class="item-title">
								{{toolsDetail.user_record.name}}
							</div>
							<div class="item-content">
								联系方式:{{toolsDetail.user_record.phone.slice(0, 3) + '****' + toolsDetail.user_record.phone.slice(7) || toolsDetail.user_record.email}}
								<!-- {{toolsDetail.user_record.phone || toolsDetail.user_record.email}} -->
							</div>
						</div>
						<div class="body-item">
							<div class="item-title">
								时间线
							</div>
							<div class="item-content">
								创建时间:{{timeConversion(toolsDetail.user_record.createtime)}}
							</div>
							<div class="item-content">
								修改时间:{{timeConversion(toolsDetail.user_record.updatetime)}}
							</div>
						</div>
						<div class="body-item">
							<div class="item-title">
								有相同需求
							</div>
							<div class="item-content" v-for="(item,index) in toolsDetail.raise_lists">
								{{item.nickname}}
							</div>
						</div>

					</div>
				</div>
				<div class="body-main">
					<div class="main-header">
						<div class="head-left">
							<img :src='getImgSrc(toolsDetail.image)' style="width: 238px;height: 238px;" alt="">
						</div>
						<div class="head-right">
							<div class="title">
								{{toolsDetail.title}}
							</div>
							<div class="content">
								<div class="content-l">

									<div class="content-item"><span
											class="biaoti">学科</span>：<span>{{toolsDetail.subjectcate_name}}</span></div>
									<div class="content-item"> <span
											class="biaoti">阶段</span>：<span>{{toolsDetail.stage_name}}</span></div>
									<div class="content-item"> <span class="biaoti">状态</span>：
										<span style="color: #0052D9;" v-if="toolsDetail.status == 2">应助中</span>
										<span style="color: #0052D9;" v-if="toolsDetail.status == 1">待审核</span>
										<span style="color: #0052D9;" v-if="toolsDetail.status == 3">已投条</span>
										<span style="color: #0052D9;" v-if="toolsDetail.status == 4">执行中</span>
										<span style="color: #0052D9;" v-if="toolsDetail.status == 5">已归档</span>
										<span style="color: #0052D9;" v-if="toolsDetail.status == 6">已存挡</span>
									</div>

									<!-- //状态:1=待审核,2=公布中,3=已投条,4=执行中,5=已归档,6=已存挡 -->

								</div>
								<div class="content-r">
									<div class="content-item"><span
											class="biaoti">行业</span>：<span>{{toolsDetail.industry_name}}</span></div>
									<div class="content-item"> <span class="biaoti">关 键
											词</span>：<span>{{toolsDetail.tags}}</span></div>

								</div>
							</div>
							<div class="bottom">
								<span style="color: #0052D9;"><i class="el-icon-view"
										style="font-size: 20px;"></i>{{toolsDetail.hits}}</span>

								<span style="margin-left:30px;cursor: pointer;"
									:style="toolsDetail.praise == 1?'color: #0052D9;':''"><i class="iconfont icon-zan"
										v-throttle="[LikeHandler,2000,`click`]"
										style="font-size:20px;"></i>{{toolsDetail.praiset_num}}</span>

								<span style="margin-left: 30px;cursor: pointer;"
									:style="toolsDetail.tread==1?'color: #0052D9;':''"><i class="iconfont icon-lacai"
										v-throttle="[ShitHandler,2000,`click`]"
										style="font-size: 18px;">{{toolsDetail.tread_num}}</i></span>

								<span style="margin-left: 30px;cursor: pointer;"
									:style="toolsDetail.collect == 1?'color: #0052D9;':''"><i class="iconfont icon-xiai"
										v-throttle="[collectasd,2000,`click`]"
										style="font-size: 18px;"></i>{{toolsDetail.collect_num}}</span>

								<div style="position: relative;" class="shareIconWrap">
									<span style="margin-left: 30px;cursor: pointer;"
										:style="toolsDetail.share == 1?'color: #0052D9;':''"><i
											class="iconfont icon-fenxiang"
											style="font-size: 20px;"></i>{{toolsDetail.share_num}}</span>
									<div class="shareIcon"
										style="position: absolute;background: #fff;width: 200px;display: flex;align-items: center;justify-content: center;left:0px;height: 50px;top:-50px">
										<goShare :zytitle="toolsDetail.title" @share='reoserceShare'></goShare>
									</div>
								</div>

							</div>
						</div>
					</div>

					<div class="main-body">
						<div class="title">
							<div :class="'active'">资源摘要</div>

						</div>
						<div class="showItem">
							<div>
								<p :style="!showDetail?'height:25px;white-space:nowrap':''">
								<p v-html="toolsDetail.summary_info"></p>
								</p>
							</div>

						</div>
						<div style="display: flex;justify-content: space-around;">
							<div @click="showDetailHandler" v-if="!showDetail"
								style="width: 209px;height: 47px;border: 1px solid #0052D9;color: #0052D9;line-height: 47px;text-align: center;cursor: pointer;">
								求助详情
							</div>
							<div @click="showDetailHandler" v-else
								style="width: 209px;height: 47px;border: 1px solid #0052D9;color: #0052D9;line-height: 47px;text-align: center;cursor: pointer;">
								收起
							</div>
							<div @click="$router.push(`/zyTools/YZneed?id=${toolsDetail.id}`)"
								style="background: #0052D9;width: 209px;height: 47px;border: 1px solid #0052D9;color: white;line-height: 47px;text-align: center;cursor: pointer;">
								应助
							</div>
						</div>
					</div>
					<div class="main-body">
						<div class="title">
							<div :class="'active'">应助情况</div>

						</div>
						<div class="showItem">
							<div class="bottom" v-if="toolsDetail.accept_lists.length == 0">尚未有人应助，提交您的资源吧！</div>
							<div v-else>
								<p class="yingzu" v-for="(item,index) in toolsDetail.accept_lists">
									<img src='../../assets/images/duidui.png' alt="" v-if="item.check_status == 1">
									<img src='../../assets/images/attion.png' alt="" v-else>
									<span>{{item.nickname}}，{{timeConversion(item.createtime)}}，应助</span><span
										v-if="item.check_status == 1">（求助人选择了此方案）
									</span>
									<span @click="$router.push(`/solutionDetail/?id=${item.id}`)">
										查看方案
									</span>
								</p>

							</div>
						</div>

					</div>
				</div>
				<el-dialog title="打赏作者" :visible.sync="centerDialogVisible" width="500px" center>
					<el-input placeholder="请输入支付积分" type="text" v-model.number='payScore'> </el-input>
					<span slot="footer" class="dialog-footer">
						<el-button @click="centerDialogVisible = false">取 消</el-button>
						<el-button type="primary" v-throttle="[giveScore,2000,`click`]">确 定</el-button>
					</span>
				</el-dialog>
				<div class="body-right">
					<div class="body-right">
						<div style="background: #0052D9;" @click="$router.push('/zyTools/createTools')">
							<img src='../../assets/images/zhifly.png' alt="" style="width: 20px;height: 18px;"><span
								style="width:80px">发布</span>
						</div>
						<div style="background: #3399FF;position: relative;" class="shareBox">
							<img src='../../assets/images/share.png' alt="" style="width: 19px;height: 19px;"><span
								style="width:80px">分享</span>
							<div class="share"
								style="position: absolute;left:0px;background: rgba(255, 255, 255, 0);width: 200px;display: flex;align-items: center;justify-content: center;left: 200px;height: 50px;">
								<goShare @share='reoserceShare' :zytitle="toolsDetail.title"></goShare>
							</div>
						</div>
						<div style="background: #FF8F00;" v-throttle="[collectasd,2000,`click`]">
							<img src='../../assets/images/whiteStar.png' alt="" style="width: 22px;height: 19px;"><span
								style="width:80px">关注</span>
						</div>
						<div style="background: #18BC9C;" v-throttle="[LikeHandler,2000,`click`]">
							<img src='../../assets/images/dianzan.png' alt="" style="width: 22px;height: 19px;"><span
								style="width:80px">点赞</span>
						</div>
						<div style="background: #182349;" v-throttle="[ShitHandler,2000,`click`]">
							<img src='../../assets/images/diancai.png' alt="" style="width: 20px;height: 19px;"><span
								style="width:80px">点踩</span>
						</div>
						<div style="background:#444C69;" @click="centerDialogVisible = true">
							<img src='../../assets/images/dashang.png' alt="" style="width: 19px;height: 19px;"><span
								style="width:80px">打赏作者</span>
						</div>
						<div style="background:#929292;"
							@click="$router.push(`/userCenter/pthd/myMessage?type=3&id=${toolsDetail.user_id}`)">
							<img src='../../assets/images/error.png' alt="" style="width: 19px;height:18px;"><span
								style="width:80px">纠错整改</span>
						</div>
						<div  style="background:brown;" @click="showDialog2 = true">
							<img src='../../assets/images/zixun.png' alt="" style="width: 19px;height: 19px;"><span
								style="width:80px">提交问题</span>
						</div>
					</div>
					<div v-if="showDialog2" class="dialog-overlay">
						<div class="dialog-content">  
						<textarea style="height: 300px;" v-model="correctionSuggestions2" placeholder="在这里输入您的问题!"></textarea>  
						<div class=".dialog-footer">
						  <button  class="submit-btn" @click="submitCorrections2">提交</button>  
						  <button  class="cancel-btn" @click="showDialog2 = false">取消</button>
						</div>
						</div>  
					</div>
				</div>
			</div>
		</div>
		<div v-if="noRoot">
			<el-empty :image-size="200" description='暂无访问权限~'></el-empty>
		</div>
	</div>
</template>

<script>
	import goShare from '../../components/share.vue'
	export default {
		components: {
			goShare
		},
		data() {
			return {
				showDialog2: false,
				correctionSuggestions2: '',
				title: '',
				whereForm: "",
				showDetail: false,
				shoucang: true,
				noLike: false,
				heart: false,
				share: false,
				toolsDetail: '',
				payScore: '',
				centerDialogVisible: false,
				actionObj: {
					collec: {
						placeholder: '点赞or取消点赞',
						getLike: async (id) => {
							return await this.$api.collectToolsQz({
								id: id
							})
						},
						cancelLice: async (id) => {
							return await this.$api.cancelCollectToolsQz({
								id: id
							})
						}
					},
				},
				noRoot: false
			}
		},
		created() {
			this.getToolDetail()
		},
		methods: {
			//提交问题
			submitCorrections2() {
			      // 调用 jiucuo 方法来提交建议  
			      this.jiucuo2();  
			}, 
			async jiucuo2(){
				if(!this.correctionSuggestions2){
					this.$message({
						message: "输入您的问题 ! ", 
						type: 'success',
					})
				}
				const alike = await this.$api.add_changjianwenti({
					user_id:this.toolsDetail.user_id,
					// pro_id:this.proDetail.id,
					// pro_title:this.proDetail.title,
					cate_list:3,
					question:this.correctionSuggestions2,
					})
				if(alike.code == 1){
					this.$message({
						message: alike.msg,
						type: 'success',
					})
					this.showDialog2 = false;  
					this.correctionSuggestions2 = ''; // 清空输入框
				}else{
					this.$message({
						message: alike.msg,
						type: 'warning',
					})
				}
				// this.alike = alike.data
			},
			// giveScoreToUserTools user_id
			async giveScore() {
				const score = await this.$api.giveScoreToUserTools({
					user_id: this.toolsDetail.user_id,
					score: this.payScore
				})
				if (score.code == 1) {
					this.$message({
						message: score.msg,
						type: 'success',
					})
					this.centerDialogVisible = false
					this.payScore = ''
				} else {
					this.$message({
						message: score.msg,
						type: 'warning',
					})
				}
				console.log(score);
			},
			async collectasd() {
				let col
				if (this.toolsDetail.collect == 0) {
					col = await this.$api.collectToolsQz({
						id: this.toolsDetail.id
					})
					if (col.code == 1) {
						this.toolsDetail.collect = 1
						this.toolsDetail.collect_num += 1
					}
				} else {
					col = await this.$api.cancelCollectToolsQz({
						id: this.toolsDetail.id
					})
					if (col.code == 1) {
						this.toolsDetail.collect = 0
						this.toolsDetail.collect_num -= 1
					}
				}
				this.$message({
					message: col.msg,
					type: 'success',
					center: true
				})
			},
			// reoserceToolShare
			async reoserceShare() {
				// 1项目需求，2资源工具求助，3资源工具，4解决方案，5解决方案求助，6产品服务求助，7产品服务
				const share = await this.$api.shareHandler({
					correlation_id: this.toolsDetail.id,
					type: 2
				})
				if (share.code == 1) {
					this.toolsDetail.share = 1
					this.toolsDetail.share_num += 1
				}
			},
			async LikeHandler() {
				let like
				if (this.toolsDetail.praise == 0) {
					like = await this.$api.getLikeToolsQz({
						id: this.toolsDetail.id
					})
					if (like.code == 1) {
						this.toolsDetail.praise = 1
						this.toolsDetail.praiset_num += 1
					}
				} else {
					like = await this.$api.cancelLikeToolsQz({
						id: this.toolsDetail.id
					})
					if (like.code == 1) {
						this.toolsDetail.praise = 0
						this.toolsDetail.praiset_num -= 1
					}
				}
				this.$message({
					message: like.msg,
					type: 'success',
					center: true
				})
			},
			// giveShitForTools
			// TakeBackShitFromTools
			async ShitHandler() {
				let shit
				if (this.toolsDetail.tread == 0) {
					shit = await this.$api.giveShitHandler({
						correlation_id: this.toolsDetail.id,
						type: 2
					})
					if (shit.code == 1) {
						this.toolsDetail.tread = 1
						this.toolsDetail.tread_num += 1
					}
				} else {
					shit = await this.$api.cancelGiveShitHandler({
						correlation_id: this.toolsDetail.id,
						type: 2
					})
					if (shit.code == 1) {
						this.toolsDetail.tread = 0
						this.toolsDetail.tread_num -= 1
					}
				}
				this.$message({
					message: shit.msg,
					type: 'success',
					center: true
				})
			},

			// getToolsQzDetail
			async getToolDetail() {
				const tool = await this.$api.getToolsQzDetail({
					id: this.$route.query.id
				})
				console.log(tool.data);
				this.toolsDetail = tool.data
				if (tool.code == 0) {
					this.noRoot = true
					this.$message({
						message: tool.msg,
						type: 'error'
					})
				}
			},
			showDetailHandler() {
				this.showDetail = !this.showDetail
			},
		},

	}
</script>

<style lang="less" scoped>
	.shareIconWrap {
		.shareIcon {
			display: none !important;
		}

		&:hover {
			.shareIcon {
				display: block !important;
			}
		}
	}

	.shareBox {
		.share {
			display: none !important;
		}

		&:hover {
			.share {
				display: block !important;
			}
		}
	}

	.body {
		display: flex;
		justify-content: space-between;

		.body-left {
			.left-body {
				.guanzhu {
					width: 230px;
					height: 46px;
					background: #0052D9;
					line-height: 46px;
					color: white;
					text-align: center;
					cursor: pointer;
				}

				.body-item {
					margin: 10px 0;
					margin-bottom: 30px;
				}

				.item-title {
					font-size: 18px;
					margin-bottom: 10px;
				}

				.item-content {
					margin: 5px 0;
					color: #888888;
				}

				padding: 10px 15px;
				box-sizing: border-box;
			}

			.left-head {
				font-size: 20px;
				line-height: 69px;
				padding-left: 15px;
				box-sizing: border-box;
				font-weight: bold;
				width: 260px;
				height: 69px;
				color: #0052D9;
				background: #E5EDFB;
			}

			width: 260px;
			background: #FFFFFF;
			box-sizing: border-box;
			align-self: flex-start;
		}

		.body-main {
			width: 900px;

			.main-body {
				.showItem {
					padding: 30px 25px;
					color: #888888;

					.bottom {
						height: 50px;
						background: #F6F6F6;
						border: 1px solid #EEEEEE;
						margin-top: 50px;
						line-height: 50px;
						padding-left: 30px;
						box-sizing: border-box;
						color: black;
					}

					.yingzu {
						display: flex;
						align-items: center;
						margin: 15px 0;

						img {
							width: 18px;
							height: 18px;
						}

						&>span {
							margin-left: 10px;
						}

						&>span:last-child {
							margin-left: 30px;
						}
					}

					p {
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.wangpan {
						color: black;
						height: 200px;

						input {
							border: 1px solid #c6c6c6;
							height: 25px;
							padding-left: 5px;
							width: 200px;
						}
					}
				}

				.title {
					display: flex;
					height: 40px;
					background: #E5EDFB;

					&>div {
						width: 128px;
						height: 40px;
						line-height: 40px;
						cursor: pointer;
						font-size: 18px;
						text-align: center;
						color: #888888;
					}

					.active {
						font-weight: bold;
						color: white;
						border-radius: 20px;
						width: 128px;
						height: 40px;
						background: #0052D9;
						border-radius: 0px 20px 20px 0px;
					}
				}

				margin-top: 20px;
				padding: 20px 0;
				box-sizing: border-box;
				background: white;
			}

			.main-header {
				display: flex;


				.content {
					margin-top: 10px;
					display: flex;

					.biaoti {
						width: 60px;
						display: inline-block;
						text-align: justify;
						text-align-last: justify;
						color: #888888;
					}

					.content-item {
						margin: 20px 5px;
						width: 280px;
					}

					.content-l {}
				}

				.bottom {
					display: flex;
					color: #888888;

					span {
						font-size: 16px;
						display: flex;
						align-items: center;
					}

					margin-top: 15px;
				}


				.head-right {
					flex: 1;
					padding: 8px 15px;
					box-sizing: border-box;

					.title {
						font-size: 20px;
						font-weight: bold;
					}
				}

				display: flex;
				background: #FFFFFF;
				padding: 20px;
				box-sizing: border-box;
				background: white;
				height: 280px;
			}
		}

		.body-right {
			flex-wrap: wrap;
			display: flex;

			&>div {
				cursor: pointer;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				line-height: 50px;
				width: 200px;
				height: 50px;
				background: #0052D9;

				&>img {
					margin-right: 15px;
				}
			}
		}
	}

	.header {
		.backof {
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}

		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;

		&>div {
			&>img {
				width: 16px;
				height: 16px;
			}

			&>p {
				font-size: 16px;
				margin-left: 10px;

				&>span {
					color: #888888;
				}
			}
		}
	}
	/* 弹出对话框的覆盖层 */
	.dialog-overlay {  
		
	}  
	  
	/* 对话框内容 */  
	.dialog-content {  
	  background: white;  
	  padding: 20px;  
	  border-radius: 8px;  
	  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);  
	  width: 400px; /* 稍微增加宽度以适应更大的文本域 */  
	  text-align: center;  
	}  
	  
	/* 文本域美化并放大 */  
	.text-area {  
	  width: 350px; /* 减去更大的左右padding */  
	  height: 500px; /* 增加高度 */  
	  padding: 20px; /* 增加内边距 */  
	  border: 1px solid #ccc;  
	  border-radius: 4px;  
	  box-sizing: border-box;  
	  margin-bottom: 20px;  
	  font-size: 16px; /* 增加字体大小 */  
	  line-height: 1.6; /* 稍微增加行高以保持可读性 */  
	  resize: none; /* 禁止用户调整文本域大小 */  
	}
	  
	/* 文本域美化 */  
	.text-area {  
	  width: calc(100% - 40px); /* 减去左右padding */  
	  padding: 10px;  
	  border: 1px solid #ccc;  
	  border-radius: 4px;  
	  box-sizing: border-box;  
	  margin-bottom: 20px;  
	  font-size: 14px;  
	  line-height: 1.5;  
	  resize: none; /* 禁止用户调整文本域大小 */  
	}  
	  
	/* 对话框底部按钮样式 */  
	.dialog-footer {  
	  display: flex;  
	  justify-content: center;  
	  gap: 10px; /* 按钮间的间距 */  
	}  
	  
	.submit-btn, .cancel-btn {  
	  padding: 10px 20px;  
	  font-size: 16px;  
	  border: none;  
	  border-radius: 4px;  
	  cursor: pointer;  
	  transition: background-color 0.3s; /* 添加过渡效果 */  
	}  
	  
	.submit-btn {  
	  background-color: #4CAF50; /* 绿色 */  
	  color: white;  
	}  
	  
	.submit-btn:hover {  
	  background-color: #45a049; /* 悬停时颜色变深 */  
	}  
	  
	.cancel-btn {  
	  background-color: #f44336; /* 红色 */  
	  color: white;  
	}  
	  
	.cancel-btn:hover {  
	  background-color: #da190b; /* 悬停时颜色变深 */  
	}  
</style>